/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  makeStyles,
  lighten,
  withStyles,
  useTheme
} from "@material-ui/core/styles";
import {
  TextField,
  InputLabel,
  Button,
  Paper,
  Snackbar,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  MenuItem,
  Select,
  IconButton,
  TableFooter,
  RadioGroup,
  Radio,
  FormControlLabel,
  setRef
} from "@material-ui/core";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import * as moment from 'moment';

import { getDeviceList, registerDevice, deleteDevice } from "../modules/Auth/_redux/deviceCrud";

import _ from "lodash";

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const useStyles4 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const StyledTableCell4 = withStyles(theme => ({
  head: {
    backgroundColor: '#298BA8', // theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow4 = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

// Example 5
const useStyles52 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    overflowX: "auto"
  }
}));

const useStyles51 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5)
  }
}));

function TablePaginationActions5(props) {
  const classes = useStyles51();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  }

  function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  }

  function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  }

  function handleLastPageButtonClick(event) {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="First Page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Last Page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions5.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};


var deviceName = '';
// var deviceType = 'NN';

export function DevicePage({ history }) {

  var initialized = false;
  var m = moment();
  var _endDt = m.format('YYYY-MM-DD')
  var _startDt = m.add(-30, 'days').format('YYYY-MM-DD')

  
  const [deviceList, setDeviceList] = React.useState([]);
  const [filterList, setFilterList] = React.useState([]);

  const [deviceType, setDeviceType] = React.useState('NN');
  const [refresh, setRefresh] = React.useState('');
  const [startDt, setStartDt] = React.useState(_startDt);
  const [endDt, setEndDt] = React.useState(_endDt);

  const [showAskDelete, setShowAskDelete] = React.useState(false);
  const [showAskSave, setShowAskSave] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const [userType, setUserType] = React.useState('');
  const [position, setPosition] = React.useState('');
  const [dept, setDept] = React.useState('');

  const [product, setProduct] = React.useState('ST');
  const [version, setVersion] = React.useState('');

  const [authMode, setAuthMode] = React.useState('SERVER');
  const [authWay, setAuthWay] = React.useState('CARD'); //  CARD, FACE, CARD_OR_FACE, CARD_AND_FACE

  const [direction, setDirection] = React.useState('OUT');
  const [imageLogEnable, setImageLogEnable] = React.useState('YES');
  const [ipAddr, setIpAddr] = React.useState('');
  const [nm, setNm] = React.useState('');
  const [openDelay, setOpenDelay] = React.useState(5);
  const [ports, setPorts] = React.useState('');


  function handleChangeProduct(event) {
    setProduct(event.target.value);
    console.log(product)
  }

  function handleChangeVersion(event) {
    setVersion(event.target.value);
  }
  function handleChangeAuthMode(event) {
    setAuthMode(event.target.value);
  }
  function handleChangeAuthWay(event) {
    setAuthWay(event.target.value);
  }
  function handleChangeDirection(event) {
    setDirection(event.target.value);
  }
  function handleChangeImageLogEnable(event) {
    setImageLogEnable(event.target.value);
  }
  function handleChangeIpAddr(event) {
    setIpAddr(event.target.value);
  }
  function handleChangeNm(event) {
    setNm(event.target.value);
  }
  function handleChangeOpenDelay(event) {
    setOpenDelay(event.target.value);
  }

  function handleChangePorts(event) {
    setPorts(event.target.value);
  }

  function handleClickAskDelete(row) {
    setSelectedRow(row);
    setShowAskDelete(true);
  }

  function handleCloseDelete() {
    setShowAskDelete(false);
  }

  function handleCloseAskSave() {
    setShowAskSave(false);
  }

  function handleActionDelete() {
    setShowAskDelete(false);

    console.log(selectedRow)

    
    const fetchData = async () => {
      try {
        const result = await deleteDevice(selectedRow.id)

        console.log('DELETE DEVICE1', result)

        if(result.data.resultCode != 'ok') {
          setTitle('Error')
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        searchDeviceList();

      } catch (error) {
        console.log('DELETE DEVICE2', error);
        setTitle('Error')
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();

  }

  function handleActionCheck() {

    console.log(product);
    console.log(version);
    console.log(authMode);
    console.log(authWay);
    console.log(direction);
    console.log(imageLogEnable);
    console.log(ipAddr);
    console.log(nm);
    console.log(openDelay);
    console.log(ports);


    if (nm == null || nm == '') {
      setTitle('Error')
      setErrorMsg('장치 이름을 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    if (version == null || version == '') {
      setTitle('Error')
      setErrorMsg('Version을 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    if (ipAddr == null || ipAddr == '') {
      setTitle('Error')
      setErrorMsg('IP 주소를 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    if (ports == null || ports == '') {
      setTitle('Error')
      setErrorMsg('포트를 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    setShowAskSave(true);
  }

  function handleActionSave() {

    setShowAskSave(false);

    const fetchData = async () => {
      try {
        const result = await registerDevice(
                                product,
                                version,
                                authMode,
                                authWay,
                                direction,
                                imageLogEnable,
                                ipAddr,
                                nm,
                                openDelay,
                                ports
                              );

        console.log('REGISTER DEVICE', result)

        if(result.data.resultCode != 'ok') {
          setTitle('Error')
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        setShowNew(false)
        searchDeviceList();

      } catch (error) {
        console.log('REGISTER DEVICE', error);
        setTitle('Error')
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();
  }

  function handleCloseNew() {
    setShowNew(false);
  }

  function newButtonClick() {
    setShowNew(true);
  }

  const [title, setTitle] = React.useState('Error');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [showSnack, setShowSnack] = React.useState(false);

  function handleCloseSnack() {
    setShowSnack(false)
  }

  function searchDeviceList() {

    const fetchData = async () => {
      try {
        const result = await getDeviceList();

        console.log('DEVICE', result.data)

        setDeviceList(result.data.list);
        filteringList(result.data.list);

      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  function filteringList(_deviceList) {

    var _filterList = [];

    console.log('FILTERING', deviceName, deviceType)
    console.log('FILTERING', _deviceList)

    for (var ii = 0; ii < _deviceList.length; ii++) {
      var hist = _deviceList[ii];

      if (deviceName != null && deviceName != '' && hist.nm.indexOf(deviceName) < 0)
        continue;

      if (deviceType != 'NN' && hist.product != deviceType)
        continue;

      console.log('HIST ]', hist);

      if (hist.createDt != null && hist.createDt != '')
        hist.createDt = hist.createDt.substr(0, 10) + ' ' + hist.createDt.substr(11, 5);

      if (hist.updateDt != null && hist.updateDt != '')
        hist.updateDt = hist.updateDt.substr(0, 10) + ' ' + hist.updateDt.substr(11, 5);

      _filterList = [..._filterList, hist];
      // filterList.push(hist);
    }

    setFilterList(_filterList);
    setRefresh('REFRESH')

    console.log('FILTERING', filterList)
  }

  function handleChangeDeviceName(event) {
    deviceName = event.target.value;
    // setRefresh('REFRESH')
  }

  function handleChangeDeviceType(event) {
    console.log(event.target.value)
    // deviceType = event.target.value;
    setDeviceType(event.target.value);
    // setRefresh('REFRESH')
  }

  const classes4 = useStyles4();
  const classes5 = useStyles52();

  const [page5, setPage5] = React.useState(0);
  const [rowsPerPage5, setRowsPerPage5] = React.useState(10);

  const emptyRows5 =
    rowsPerPage5 - Math.min(rowsPerPage5, filterList.length - page5 * rowsPerPage5);

  function handleChangePage5(event) {
    setPage5(parseInt(event.target.value));
  }

  function handleChangeRowsPerPage5(event) {
    setRowsPerPage5(parseInt(event.target.value, 10));
  }

  useEffect(() => {
    searchDeviceList();
  }, [])

  return (
    <>

      <div className="row">
        <div className="col-md-2">

          <TextField
            id="standard-name"
            label="장치이름"
            className={classes4.textField}
            onChange={handleChangeDeviceName}
            margin="normal"
          />

        </div>
        <div className="col-md-2">
          <Select
            value={deviceType}
            className={classes4.textField}
            onChange={handleChangeDeviceType}
            style={{
              bottom: '17px',
              width: '80%',
              marginBottom: '-9px',
              position: 'absolute'
            }}
          >
            <MenuItem value='NN'>종류선택</MenuItem>
            <MenuItem value='ST'>ST</MenuItem>
            <MenuItem value='RT'>RT</MenuItem>
          </Select>
        </div>
        <div className="col-md-2">
          <Button variant="contained" color="secondary" className={classes4.button}
            onClick={searchDeviceList}
            style={{
              position: 'absolute',
              bottom: '8px',
              left: '18px'
            }}>
            검색
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
        <div className="col-md-6">
          <Button variant="contained" color="secondary" className={classes4.button}
            onClick={newButtonClick}
            style={{
              position: 'absolute',
              bottom: '8px',
              right: '18px'
            }}>
            장치추가
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
      </div>

      {/*<div className="separator separator-dashed my-7"></div>*/}
      <div className="row">
        <div className="col-md-12">

          <Paper className={classes5.root}>
            <div className={classes5.tableWrapper}>
              <Table className={classes5.table}>

                <TableHead>
                  <TableRow>

                    <StyledTableCell4 style={{ width: '100px' }} align="center">장치번호</StyledTableCell4>
                    <StyledTableCell4 align="center">장치이름</StyledTableCell4>
                    <StyledTableCell4 align="center">종류</StyledTableCell4>
                    <StyledTableCell4 align="center">IP</StyledTableCell4>
                    <StyledTableCell4 align="center">Port</StyledTableCell4>
                    <StyledTableCell4 align="center">인증 방식</StyledTableCell4>
                    <StyledTableCell4 align="center">인증 모드</StyledTableCell4>
                    <StyledTableCell4 align="center">등록일시</StyledTableCell4>
                    <StyledTableCell4 align="center"> </StyledTableCell4>
                  </TableRow>
                </TableHead>

                <TableBody id={refresh}>
                  {filterList
                    .slice(
                      page5 * rowsPerPage5,
                      page5 * rowsPerPage5 + rowsPerPage5
                    )
                    .map(row => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row" align="center">
                          {row.id}
                        </TableCell>

                        <TableCell align="center">{row.nm}</TableCell>
                        <TableCell align="center">{row.product}</TableCell>
                        <TableCell align="center">{row.ipAddr}</TableCell>
                        <TableCell align="center">{row.ports}</TableCell>
                        <TableCell align="center">{row.authMode}</TableCell>
                        <TableCell align="center">{row.authWay}</TableCell>
                        <TableCell align="center">{row.createDt}</TableCell>
                        <TableCell align="center" style={{ padding: '0' }}>

                          <Button size="small" className={classes4.margin}
                            onClick={handleClickAskDelete.bind(this, row)}
                            style={{ color: 'orangered', margin: 0 }}>
                            <DeleteIcon className={classes4.deleteIcon} />
                          </Button>
                        </TableCell>

                      </TableRow>
                    ))}

                  {emptyRows5 > 0 && (
                    <TableRow style={{ height: 48 * emptyRows5 }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      // rowsPerPageOptions={[5, 10, 25]}
                      colSpan={3}
                      count={filterList.length}
                      rowsPerPage={rowsPerPage5}
                      page={page5}
                      /*SelectProps={{
                        inputProps: { "aria-label": "Rows per page" },
                        native: true
                      }}*/
                      onChangePage={handleChangePage5}
                      onChangeRowsPerPage={handleChangeRowsPerPage5}
                      ActionsComponent={TablePaginationActions5}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </Paper>

        </div>

      </div>

      <Dialog
        open={showAskDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 장치를 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionDelete} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSave}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 장치를 등록하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAskSave} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSave} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        maxWidth={'640px'}
        open={showNew}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">장치 등록</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* <div style={{ visibility: 'hidden' }}><span>sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </span></div> */}
          </DialogContentText>

          <div className="row">

            <div className="col-md-6">
              <TextField
                autoFocus
                margin="dense"
                id="nm"
                value={nm} 
                onChange={handleChangeNm}
                label="이름"
                type="text"
                fullWidth
              />
            </div>

            <div className="col-md-6">
              <TextField
                margin="dense"
                id="version"
                value={version}
                label="Version"
                type="text"
                onChange={handleChangeVersion}
                fullWidth
              />
            </div>
          </div>


          <div className="row">

            <div className="col-md-6">
              <TextField
                margin="dense"
                id="ipAddr"
                label="IP"
                value={ipAddr}
                onChange={handleChangeIpAddr}
                type="email"
                fullWidth
              />
            </div>

            <div className="col-md-6">
              <TextField
                margin="dense"
                id="ports"
                label="Port"
                value={ports}
                onChange={handleChangePorts}
                type="phone"
                fullWidth
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: '24px' }}>
            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">인증방식</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangeAuthWay}
                value={authWay}
                style={{ width: '100%' }}
              >
                <MenuItem value='CARD'>카드</MenuItem>
                <MenuItem value='FACE'>얼굴</MenuItem>
                <MenuItem value='CARD_OR_FACE'>카드 또는 얼굴</MenuItem>
                <MenuItem value='CARD_AND_FACE'>카드와 얼굴</MenuItem>
              </Select>
            </div>

            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">인증모드</InputLabel>
              <Select
                className={classes4.textField}
                value={authMode}
                onChange={handleChangeAuthMode}
                style={{ width: '100%' }}
              >
                <MenuItem value='SERVER'>서버</MenuItem>
                <MenuItem value='TERMINAL'>단말</MenuItem>
              </Select>
            </div>

            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">기본 열림시간</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangeOpenDelay}
                value={openDelay}
                style={{ width: '100%' }}
              >
                <MenuItem value='3'>3초</MenuItem>
                <MenuItem value='5'>5초</MenuItem>
                <MenuItem value='10'>10초</MenuItem>
                <MenuItem value='15'>15초</MenuItem>
                <MenuItem value='20'>20초</MenuItem>
                <MenuItem value='30'>30초</MenuItem>
              </Select>
            </div>
          </div>


          <div className="row" style={{ marginTop: '24px' }}>
            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">종류</InputLabel>
              <RadioGroup
                aria-label="방향"
                name="gender1"
                className={classes4.group}
                value={product}
                onChange={handleChangeProduct}
              >
                <div>
                  <FormControlLabel value="ST" control={<Radio />} label="ST" />
                  <FormControlLabel value="RT" control={<Radio />} label="RT" />
                </div>
              </RadioGroup>
            </div>

            <div className="col-md-4">

              <InputLabel htmlFor="age-simple">방향</InputLabel>
              <RadioGroup
                aria-label="Gen방향der"
                name="gender1"
                className={classes4.group}
                value={direction}
                onChange={handleChangeDirection}
              >
                <div>
                  <FormControlLabel value="OUT" control={<Radio />} label="Out" />
                  <FormControlLabel value="IN" control={<Radio />} label="In" />
                </div>
              </RadioGroup>
            </div>

            <div className="col-md-4">

              <InputLabel htmlFor="age-simple">이미지 로그 사용</InputLabel>
              <RadioGroup
                aria-label="Gen방향der"
                name="gender1"
                className={classes4.group}
                value={imageLogEnable}
                onChange={handleChangeImageLogEnable}
              >
                <div>
                  <FormControlLabel value="YES" control={<Radio />} label="Yes" />
                  <FormControlLabel value="NO" control={<Radio />} label="No" />
                </div>
              </RadioGroup>
            </div>
          </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNew} color="primary">
            취소
          </Button>
          <Button onClick={handleActionCheck} color="primary">
            저장
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showSnack}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ minWidth: '320px' }}
      >
        <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSnack} color="primary" autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}


